import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaSimulationLmnpFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        investedAmount: [
          entity ? entity.investedAmount : null,
          Validators.required,
        ],
        duration: [entity ? entity.duration : null, Validators.required],
        rentalReport: [
          entity ? entity.rentalReport : null,
          Validators.required,
        ],
        propertyRevaluation: [
          entity ? entity.propertyRevaluation : null,
          Validators.required,
        ],
        rentalReversion: [
          entity ? entity.rentalReversion : null,
          Validators.required,
        ],

        notaryFees: [entity ? entity.notaryFees : null, Validators.required],
        estateTax: [entity ? entity.estateTax : null, Validators.required],
        managementFeesPercentage: [
          entity ? entity.managementFeesPercentage : null,
          Validators.required,
        ],
        coOwnershipFeesPercentage: [
          entity ? entity.coOwnershipFeesPercentage : null,
          Validators.required,
        ],

        cashOrCredit: [
          entity ? entity.cashOrCredit : null,
          [
            this.prFormService.RefreshEveryValidators([
              'loanDuration',
              'loanRate',
            ]),
          ],
        ],
        loanDuration: [
          entity ? entity.loanDuration : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('cashOrCredit', 'CREDIT')
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        loanRate: [entity ? entity.loanRate : null, Validators.required],

        bankingFees: [entity ? entity.bankingFees : null, Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      investedAmount: this.emptyIsNull(this.form.value.investedAmount),
      duration: this.emptyIsNull(this.form.value.duration),
      rentalReport: this.emptyIsNull(this.form.value.rentalReport),
      propertyRevaluation: this.emptyIsNull(
        this.form.value.propertyRevaluation,
      ),
      rentalReversion: this.emptyIsNull(this.form.value.rentalReversion),

      notaryFees: this.emptyIsNull(this.form.value.notaryFees),
      estateTax: this.emptyIsNull(this.form.value.estateTax),
      managementFeesPercentage: this.emptyIsNull(
        this.form.value.managementFeesPercentage,
      ),
      coOwnershipFeesPercentage: this.emptyIsNull(
        this.form.value.coOwnershipFeesPercentage,
      ),

      cashOrCredit: this.emptyIsNull(this.form.value.cashOrCredit),
      loanDuration: this.emptyIsNull(this.form.value.loanDuration),
      loanRate: this.emptyIsNull(this.form.value.loanRate),

      bankingFees: this.emptyIsNull(this.form.value.bankingFees),
    };
    return dto;
  }
}
